
const Agro = {
  init() {
  },



};

export default Agro;
